import { ICalendarEvent } from 'interface/calendar'

function parseTime(time: string): number {
  const [hours, minutes, seconds] = time.split(':').map(Number)
  return hours * 3600 + minutes * 60 + seconds
}

export function groupOverlappingEvents(events: ICalendarEvent[]): ICalendarEvent[][] {
  // Parse and sort events by start time
  const sortedEvents = events.map(event => ({
    ...event,
    startTime: parseTime(event.start_at),
    endTime: parseTime(event.end_at)
  })).sort((a, b) => a.startTime - b.startTime)

  const groupedEvents: ICalendarEvent[][] = []
  let currentGroup: ICalendarEvent[] = []

  for (const event of sortedEvents) {
    if (currentGroup.length === 0) {
      currentGroup.push(event)
    } else {
      const lastEvent = currentGroup[currentGroup.length - 1]
      if (parseTime(event.start_at) <= parseTime(lastEvent.end_at)) {
        currentGroup.push(event)
      } else {
        groupedEvents.push(currentGroup)
        currentGroup = [event]
      }
    }
  }

  if (currentGroup.length > 0) {
    groupedEvents.push(currentGroup)
  }

  return groupedEvents
}
